import { useI18n } from "@/i18n";
import { Check, X } from "lucide-react";

const WhyLocalAI = () => {
  const { language } = useI18n();

  const cloudItems = language === 'en' ? [
    'Data sent to external servers',
    'Requires internet connection',
    'Per-token costs that scale',
    'Complex compliance review',
    'Outage and breach risks',
  ] : [
    '数据传输到外部服务器',
    '需要持续联网',
    '按 token 持续收费',
    '复杂的合规审查',
    '宕机与泄露风险',
  ];

  const localItems = language === 'en' ? [
    'Data never leaves your device',
    'Works completely offline',
    'No recurring fees or limits',
    'GDPR, CCPA, PIPL by design',
    'Zero external dependency',
  ] : [
    '数据永不离开设备',
    '完全离线可用',
    '无持续费用、无限制',
    '架构级满足 GDPR、CCPA、PIPL',
    '不依赖任何外部服务',
  ];

  return (
    <section className="py-24 md:py-32 bg-[#111827]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              {language === 'en' ? 'Why Local AI Matters' : '为什么选择本地 AI'}
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              {language === 'en'
                ? 'Your data stays on your Mac. Period.'
                : '你的数据留在你的 Mac 上。就这么简单。'}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Cloud AI */}
            <div className="bg-white/5 rounded-2xl p-8">
              <h3 className="text-lg font-semibold mb-6 text-gray-400">
                {language === 'en' ? 'Cloud AI' : '云端 AI'}
              </h3>
              <ul className="space-y-4">
                {cloudItems.map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                      <X className="w-3 h-3 text-red-400" />
                    </div>
                    <span className="text-gray-400 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Local AI */}
            <div className="bg-white/10 border border-white/20 rounded-2xl p-8">
              <h3 className="text-lg font-semibold mb-6 text-white">
                {language === 'en' ? 'Local AI with Estha' : 'Estha 本地 AI'}
              </h3>
              <ul className="space-y-4">
                {localItems.map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center">
                      <Check className="w-3 h-3 text-emerald-400" />
                    </div>
                    <span className="text-white text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyLocalAI;
